/**
 * Swiper Gallery Component (Swiper v12 compatible)
 * Initializes a responsive image gallery carousel with custom pagination and navigation
 * Used on intensives page location gallery section
 */

import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard } from 'swiper/modules';

/**
 * Create and initialize a Swiper gallery instance
 * @param {string} containerId - ID of the swiper container element (without #)
 * @returns {Swiper|null} - The initialized Swiper instance, or null if not found / already initialized
 */
export function createSwiperGallery(containerId) {
  if (!containerId) return null;

  const el = document.getElementById(containerId);
  if (!el) return null;

  // Prevent double-initialization (helpful when bundled across multiple pages)
  if (el.dataset.swiperGalleryInitialized === 'true') {
    return el.swiper || null;
  }
  el.dataset.swiperGalleryInitialized = 'true';

  const paginationEl = el.querySelector('.swiper-custom-pagination');

  // Prefer navigation buttons scoped to this gallery, but fall back to the legacy IDs if needed
  const nextEl =
    el.querySelector('.swiper-button-next') ||
    document.querySelector('#nav-right');

  const prevEl =
    el.querySelector('.swiper-button-prev') ||
    document.querySelector('#nav-left');

  return new Swiper(el, {
    // Swiper 12: register modules per instance
    modules: [Navigation, Pagination, Keyboard],

    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 24,
    loop: true,

    keyboard: {
      enabled: true,
    },

    pagination: paginationEl
      ? {
        el: paginationEl,
        clickable: true,
        renderBullet(index, className) {
          return `<div class="${className}">
              <span class="number">${index + 1}</span>
              <span class="line"></span>
            </div>`;
        },
      }
      : undefined,

    navigation:
      nextEl && prevEl
        ? {
          nextEl,
          prevEl,
        }
        : undefined,

    breakpoints: {
      800: {
        slidesPerView: 1.5,
      },
      1400: {
        slidesPerView: 3,
      },
    },
  });
}

export default createSwiperGallery;
